
import { defineComponent } from 'vue'
import ValueFormatter from '@/utils/value-formatter'
import { ReportTable, ReportData } from '@/model/models'

export default defineComponent( {
  name: 'ReportTableView',
  props: {
    table: ReportTable,
    data: ReportData
  },
  data() {
    return {
      sortIndex: -1,
      sortDown: false
    }
  },
  methods: {
    format(value: any, format: string | null) {
      return ValueFormatter.format(value, format)
    },
    isNumber(format: string) {
      return ValueFormatter.isNumberFormat(format)
    },
    hasLink(index: number) {
      return this.table?.columns[index].link.length
    },
    makeLink(record: any[], pattern: string) {
      if (this.data) {
        var link = pattern

        const vars = pattern?.match(/\{([^)]+)\}/g)
        vars?.forEach(v => {
          const index = this.data!.columns.indexOf(v.replace('{', '').replace('}', ''))
          link = link.replace(v, index >= 0 ? record[index] : '')
        })

        return link
      }

      return ''
    },
    sort(index: number) {
      if (this.sortIndex === index) {
        this.sortDown = !this.sortDown
      } else {
        this.sortIndex = index
        this.sortDown = false
      }
    }
  },
  computed: {
    sortedValues() {
      if (this.data && this.table) {
        const indices = this.table!.columns.map(col => this.data!.columns.indexOf(col.value))
        const sorted = this.data!.values.map((row => indices.map(index => row[index])))

        sorted.sort((v1, v2) => {
          const v = v1[this.sortIndex] > v2[this.sortIndex] ? 1 : (v1[this.sortIndex] < v2[this.sortIndex] ? -1 : 0)
          return this.sortDown ? 0 - v : v
        })

        return sorted
      }

      return []
    }
  }
})
